import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

import {GridList, GridTile} from 'material-ui/GridList';
import {CardTitle} from 'material-ui/Card';
import IconButton from 'material-ui/IconButton';
import Subheader from 'material-ui/Subheader';
import StarBorder from 'material-ui/svg-icons/toggle/star-border';

const styles = {
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
  },
  gridList: {
    overflowY: 'auto',
  },
};

class Seemore extends Component {
  state = {
    type: 'place',
    data: []
  }
  componentDidMount() {
    const { match } = this.props
    const { types, id } = match.params
    if (types === 'popularPlace') {
      this.setState({
        type: 'place',
        data: this.props.place
      })
    }
    if (types === 'popularFood') {
      this.setState({
        type: 'food',
        data: this.props.food
      })
    }
    if (types === 'popularOtop') {
      this.setState({
        type: 'otop',
        data: this.props.otop
      })
    }
    if (types === 'popularHotels') {
      this.setState({
        type: 'hotels',
        data: this.props.hotels
      })
    }
    if (types === 'popularNews') {
      this.setState({
        type: 'news',
        data: this.props.news
      })
    }
  }
  renderContent() {
    const { match } = this.props
    const { types, id } = match.params
    if (this.state.data) {
      return (
        <div style={styles.root}>
          <GridList
            cellHeight={180}
            style={styles.gridList}
          >
            {this.state.data.map((tile) => (
              <GridTile
                containerElement={<Link to={'/details/'+types+'/'+tile.id} />}
                key={tile.img}
                title={<b>{tile.title}</b>}
                subtitle={this.props.category.find(value => value.id === tile.category_id)['title_'+this.props.lang]}
              >
                <img src={tile.cover_photo} />
              </GridTile>
            ))}
          </GridList>
        </div>
      )
    }
  }
  render() {
    const title = {
      place: 'สถานที่ยอดนิยม',
      food: 'ร้านอาหารยอดนิยม',
      otop: 'สินค้ายอดนิยม',
      hotels: 'ที่พักยอดนิยม',
      news: 'ข่าว',
    }
    return (
      <div>
        <h3>{title[this.state.type]}</h3>
        {this.renderContent()}
      </div>
    )
  }
}

const mapStateToProps = state => ({
  place: state.place.popular.data,
  food: state.food.popular.data,
  otop: state.otop.popular.data,
  hotels: state.hotels.popular.data,
  news: state.news.popular.data,
  category: state.category,
})
export default connect(mapStateToProps)(Seemore)
  


// WEBPACK FOOTER //
// ./src/containers/Seemore/Seemore.js